export default "__VITE_ASSET__8ca36a49__"